import { getApiUrl } from '../../config/api-endpoints.js';

function efemGatewayPath(gatewaySerialNumber: string): string {
  return encodeURIComponent(gatewaySerialNumber);
}

/** Unified SSE for job progress (`GET /api/tenant/jobs/:jobId/events`). */
export function getJobEventsUrl(jobId: string, jobType?: string): string {
  const params = new URLSearchParams();
  if (jobType) {
    params.set('jobType', jobType);
  }
  const qs = params.toString();
  return `${getApiUrl()}/tenant/jobs/${encodeURIComponent(jobId)}/events${qs ? `?${qs}` : ''}`;
}

export function getEfemLocksEventsUrl(): string {
  return `${getApiUrl()}/tenant/efem/locks/events`;
}

export function getFingerprintInferenceBatchEventsUrl(batchId: string): string {
  return `${getApiUrl()}/tenant/fingerprint-inference/batches/${encodeURIComponent(batchId)}/events`;
}

export function getLabelLinkHandheldEventsUrl(sessionId: string): string {
  return `${getApiUrl()}/tenant/inventory-labels/handheld-sessions/${sessionId}/events`;
}

export function getEfemLoadPortEventsUrl(gatewaySerialNumber: string): string {
  return `${getApiUrl()}/tenant/efem/clients/${efemGatewayPath(gatewaySerialNumber)}/loadports/events`;
}
